
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BottomNav from '../../components/feature/BottomNav';

const MyTripsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('upcoming');

  const upcomingTrips = [
    {
      id: 1,
      type: 'flight',
      from: 'الرياض',
      to: 'جدة',
      date: '2024-01-15',
      time: '14:30',
      airline: 'الخطوط السعودية',
      bookingRef: 'SA123456',
      status: 'confirmed'
    },
    {
      id: 2,
      type: 'bus',
      from: 'الدمام',
      to: 'الرياض',
      date: '2024-01-20',
      time: '09:00',
      company: 'سابتكو',
      bookingRef: 'BUS789012',
      status: 'confirmed'
    }
  ];

  const pastTrips = [
    {
      id: 3,
      type: 'flight',
      from: 'جدة',
      to: 'القاهرة',
      date: '2023-12-10',
      time: '16:45',
      airline: 'مصر للطيران',
      bookingRef: 'MS345678',
      status: 'completed'
    }
  ];

  const handleBackClick = () => {
    navigate('/home');
  };

  const handleSearchClick = () => {
    // يمكن إضافة وظيفة البحث هنا
    console.log('البحث في الرحلات');
  };

  const handleBookNewTrip = () => {
    navigate('/home');
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'confirmed':
        return 'text-green-600 bg-green-50';
      case 'completed':
        return 'text-gray-600 bg-gray-50';
      case 'cancelled':
        return 'text-red-600 bg-red-50';
      default:
        return 'text-blue-600 bg-blue-50';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'confirmed':
        return 'مؤكد';
      case 'completed':
        return 'مكتمل';
      case 'cancelled':
        return 'ملغي';
      default:
        return 'قيد المراجعة';
    }
  };

  const renderTripCard = (trip: any) => (
    <div key={trip.id} className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 mb-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2 space-x-reverse">
          <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
            <i className={`ri-${trip.type === 'flight' ? 'flight-takeoff' : 'bus'}-line text-blue-600 text-sm`}></i>
          </div>
          <span className="text-sm text-gray-600">
            {trip.type === 'flight' ? trip.airline : trip.company}
          </span>
        </div>
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(trip.status)}`}>
          {getStatusText(trip.status)}
        </span>
      </div>

      <div className="flex items-center justify-between mb-3">
        <div className="text-center">
          <div className="font-semibold text-gray-900">{trip.from}</div>
          <div className="text-xs text-gray-500">{trip.time}</div>
        </div>
        <div className="flex-1 mx-4">
          <div className="flex items-center justify-center">
            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
            <div className="flex-1 h-0.5 bg-gray-200 mx-2"></div>
            <i className={`ri-${trip.type === 'flight' ? 'flight-takeoff' : 'bus'}-line text-blue-600 text-sm`}></i>
            <div className="flex-1 h-0.5 bg-gray-200 mx-2"></div>
            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
          </div>
        </div>
        <div className="text-center">
          <div className="font-semibold text-gray-900">{trip.to}</div>
          <div className="text-xs text-gray-500">{trip.date}</div>
        </div>
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-gray-100">
        <div className="text-sm text-gray-600">
          رقم الحجز: <span className="font-medium">{trip.bookingRef}</span>
        </div>
        <button className="text-blue-600 text-sm font-medium">
          عرض التفاصيل
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm fixed top-0 left-0 right-0 z-10 h-16">
        <div className="flex items-center justify-between h-full px-4">
          <button 
            onClick={handleBackClick}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0"
          >
            <i className="ri-arrow-right-line text-xl text-gray-700"></i>
          </button>
          <h1 className="text-lg font-semibold text-gray-900 truncate mx-4">رحلاتي</h1>
          <button 
            onClick={handleSearchClick}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 flex-shrink-0"
          >
            <i className="ri-search-line text-xl text-gray-700"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-16 pb-20 px-4">
        {/* Tabs */}
        <div className="bg-white rounded-xl p-1 mb-6 shadow-sm">
          <div className="grid grid-cols-2 gap-1">
            <button
              onClick={() => setActiveTab('upcoming')}
              className={`py-3 px-4 rounded-lg text-sm font-medium transition-colors ${
                activeTab === 'upcoming'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              الرحلات القادمة
            </button>
            <button
              onClick={() => setActiveTab('past')}
              className={`py-3 px-4 rounded-lg text-sm font-medium transition-colors ${
                activeTab === 'past'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              الرحلات السابقة
            </button>
          </div>
        </div>

        {/* Trip Cards */}
        {activeTab === 'upcoming' && (
          <div>
            {upcomingTrips.length > 0 ? (
              upcomingTrips.map(renderTripCard)
            ) : (
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-flight-takeoff-line text-2xl text-gray-400"></i>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">لا توجد رحلات قادمة</h3>
                <p className="text-gray-500 mb-6">احجز رحلتك القادمة الآن</p>
                <button 
                  onClick={handleBookNewTrip}
                  className="bg-blue-600 text-white px-6 py-3 rounded-xl font-medium"
                >
                  احجز رحلة جديدة
                </button>
              </div>
            )}
          </div>
        )}

        {activeTab === 'past' && (
          <div>
            {pastTrips.length > 0 ? (
              pastTrips.map(renderTripCard)
            ) : (
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-history-line text-2xl text-gray-400"></i>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">لا توجد رحلات سابقة</h3>
                <p className="text-gray-500">ستظهر رحلاتك المكتملة هنا</p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default MyTripsPage;
